import React, { useState, useEffect, useRef } from 'react';
import Loader from 'react-loader-spinner';
import Highcharts from 'highcharts';
// import HighStock from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { Hidden, useMediaQuery } from '@material-ui/core';

import 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import {
	MuiPickersUtilsProvider,
	KeyboardDatePicker,
} from '@material-ui/pickers';

import { Submenu, SubmenuItem, TabelaCalendario } from '../../components';

import { etfService, documentsService } from '../../service';
import {
	formatDbDate,
	formatDate,
	getDateTimeString,
	smoothScroll,
	formatCurrencyToBRL,
	convertBRLDateToDate,
	convertBRLDateToString,
	formatPercent,
} from '../../utils/functions';

import {
	Container,
	Title,
	PeriodOptions,
	PeriodOption,
	DateOptions,
	BoxAcumulado,
	ContentAcumulado,
	BoxMensal,
	BoxMensalVolume,
	ContentMensal,
	TabelaMensal,
	BoxVolume,
	ContentVolume,
	TabelaVolume,
	BoxEvolucao,
	ContentEvolucao,
	TabelaEvolucao,

} from './styles';

var formatter = new Intl.NumberFormat('pt-BR', {
	style: 'decimal',
	currency: 'BRL',
	// These options are needed to round to whole numbers if that's what you want.
	minimumFractionDigits: 4, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
	//maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

const getMensal = list => {
	return list.map(item => [
		formatDbDate('MM/YYYY', item.Data),
		formatCurrencyToBRL(item.CotaPatrimonial),
		formatCurrencyToBRL(item.IndiceReferencia),
		formatCurrencyToBRL(item.PercIndiceReferencia),
	]);
};
const getVolume = list => {
	return list.map(item => [
		formatDbDate('DD/MM/YYYY', item.Data),
		formatCurrencyToBRL(item.VolumeETFNegociadas),
	]);
};
const getEvolucao = list => {
	return list.map(item => [
		formatDbDate('DD/MM/YYYY', item.Data),
		formatCurrencyToBRL(item.PatrimonioLiquido),
		item.CotaPatrimonial.toFixed(7).replace('.', ','),
		// formatCurrencyToBRL(item.CotacaoETFB3Med),
		formatCurrencyToBRL(item.CotacaoETFB3Fech),
		// formatCurrencyToBRL(item.IndiceReferenciaMed),
		formatCurrencyToBRL(item.IndiceReferenciaFech),
		// formatCurrencyToBRL(item.AgiDesagiCotacoesIndiceMedio),
		formatter.format(item.AgiDesagiCotacoesIndiceFech),
		// formatCurrencyToBRL(item.AgiDesagiCotacoesCotaMedio),
		formatter.format(item.AgiDesagiCotacoesCotaFech),
	]);
};
const periodLabel = {
	acumulada: 3,
	'6m': 1,
	'1a': 2,
	inicio: 3,
};

const actualYear = new Date().getFullYear();
const actualMonth = parseInt(new Date().getMonth() + 1);

const initialOptions = {
	chart: {
		type: 'spline',
	},

	credits: { enabled: false },

	title: {
		text: undefined,
	},

	tooltip: {
		shared: true,
		useHTML: true,
		headerFormat:
			'<p class="tooltipHeader">{point.key}</p><table class="tooltipInfo">',
		pointFormat:
			'<tr><td style="color: {series.color}">{series.name}:</td>' +
			'<td><div style="background-color: {series.color}"> {point.y_info:.3f}%</div></td><td style="color: {series.color}">{point.info}</td></tr>',
		footerFormat: '</table>',
	},

	plotOptions: {
		series: {
			compare: 'percent',
		},
	},

	yAxis: {
		title: {
			text: 'Rentabilidade (%)',
		},
		labels: {
			formatter: function () {
				return formatCurrencyToBRL(this.value);
			},
		},
	},

	series: [
		{
			name: 'ETF BTG Pactual Commodities',
			color: '#00467D',
			label: {
				formatter: function () {
					return 'R$ ' + formatCurrencyToBRL(this.value);
				},
			},
		},
		{
			name: 'Índice Teva Ações Commodities Brasil',
			color: '#00467D',
			label: {
				formatter: function () {
					return 'R$ ' + formatCurrencyToBRL(this.value);
				},
			},
		},
		{
			name: 'Índice Bovespa',
			color: '#418FDE',
			label: {
				formatter: function () {
					return 'R$ ' + formatCurrencyToBRL(this.value) + " pontos";
				},
			},
		},
	],
};

export default () => {
	const matches = useMediaQuery('(max-width:768px)');

	const [chart, setChart] = useState(initialOptions);
	const [mensalData, setMensalData] = useState(null);
	const [volumeData, setVolumeData] = useState(null);
	const [evolucaoData, setEvolucaoData] = useState(null);
	const [beginDate, setBeginDate] = useState(null);
	const [endDate, setEndDate] = useState(null);

	const acumuladoRef = useRef(null);
	const mensalRef = useRef(null);
	const volumeRef = useRef(null);
	const evolucaoRef = useRef(null);

	const [rentabilidadeMensalDate, setRentabilidadeMensalDate] = useState(null);
	const [volumeNegociadoDate, setVolumeNegociadoDate] = useState(null);
	const [evolucaoDiariaDate, setEvolucaoDiariaDate] = useState(null);

	const [anosReferencia, setAnosReferencia] = useState(null);

	const getAnosReferencia = async () => {

		try{

			const response = await etfService.AnosReferenciaRentabilidade();
			const responseData = await response.data;
			setAnosReferencia(Array.from(responseData.ObjJsonResultado));

		}
		catch (err){

			console.log('Ocorreu um erro ao chamar a API de Rentabilidade/Anos de Referência - Erro: ',
			err,);

		}
	}

	const getDateAtualizacao = async () => {
		try {
			const response = await etfService.DatesAtualizacaoRentabilidade();
			const responseData = await response.data;

			setRentabilidadeMensalDate(responseData.ObjJsonResultado.RentabilidadeMensal);
			setVolumeNegociadoDate(responseData.ObjJsonResultado.VolumeNegocidado);
			setEvolucaoDiariaDate(responseData.ObjJsonResultado.EvolucaoDiaria);

		} catch (err) {
			setRentabilidadeMensalDate("");
			setVolumeNegociadoDate("");
			setEvolucaoDiariaDate("");
			console.error(
				'Ocorreu um erro ao chamar a API de Rentabilidade/Datas de atualização - Erro: ',
				err,
			);
		}
	};


	const getRentabilidadeMensal = async () => {
		try {

			var yearRequest;
			var monthRequest;

			const response = await etfService.RentabilidadeMensal(
				actualYear,
				actualMonth,
			);
			const responseData = await response.data;

			const mensal = getMensal(
				responseData.ObjJsonResultado.RentabilidadeMensal,
			);

			setMensalData(mensal);
		} catch (err) {
			setMensalData([]);

			console.error(
				'Ocorreu um erro ao chamar a API de Rentabilidade Mensal - Erro: ',
				err,
			);
		}
	};

	const getVolumeDiario = async () => {
		try {
			const response = await etfService.RentabilidadeVolume(
				actualYear,
				actualMonth,
			);
			const responseData = await response.data;

			const volume = getVolume(responseData.ObjJsonResultado.VolumeNegociado);

			setVolumeData(volume);
		} catch (err) {
			setVolumeData([]);

			console.error(
				'Ocorreu um erro ao chamar a API de Rentabilidade Volume - Erro: ',
				err,
			);
		}
	};

	const getEvolucaoDiaria = async () => {
		try {
			const response = await etfService.RentabilidadeEvolucao(
				actualYear,
				actualMonth,
			);
			const responseData = await response.data;

			const evolucao = getEvolucao(
				responseData.ObjJsonResultado.EvolucaoDiaria,
			);
			setEvolucaoData(evolucao);
		} catch (err) {
			setEvolucaoData([]);

			console.error(
				'Ocorreu um erro ao chamar a API de Rentabilidade Evolucao Diaria - Erro: ',
				err,
			);
		}
	};

	const resetChart = () =>
		setChart(prev => {
			return {
				...prev,
				series: [
					{
						...prev?.series[0],
						data: null,
					},
					{
						...prev?.series[1],
						data: null,
					},
					{
						...prev?.series[2],
						data: null,
					},
				],
			};
		});

	const getChart = async (
		beginDateParam = null,
		endDateParam = null,
		periodParam = null,
	) => {
		try {
			resetChart();

			const date = { begin: null, end: null };

			if (beginDateParam) {
				date.begin = formatDate('YYYY-MM-DD', beginDateParam);
			}

			if (endDateParam) {
				date.end = formatDate('YYYY-MM-DD', endDateParam);
			}

			const response = await etfService.RentabilidadeAcumulada(
				date.begin,
				date.end,
				periodParam,
			);
			const responseData = await response.data.ObjJsonResultado;

			if (responseData?.periodos?.periodo?.length > 0) {
				const categories = responseData.periodos.periodo.map(
					convertBRLDateToString,
				);

				var formato = { maximumFractionDigits: 10 , style: 'currency', currency: 'BRL' }

				const etf = {
					values: responseData.series[0].etf.map((e, index) => {
						return {
							name: categories[index],
							valor: e.valor,
							info: e.valor.toLocaleString('pt-BR', formato),
							y: e.PercetualIndiceRef,
							y_info: e.PercetualIndiceRef.toFixed(2).toLocaleString('pt-br')
						};
					}),
					labels: responseData.series[0].etf.map(e => e.PercetualIndiceRef),
				};
				const ind = {
					values: responseData.series[0].indice.map((e, index) => {
						return {
							name: categories[index],
							valor: e.valor,
							info: e.valor.toLocaleString('pt-BR') + " pts",
							y: e.PercetualIndiceRef,
							y_info: e.PercetualIndiceRef.toFixed(2).toLocaleString('pt-br')
						};
					}),
					labels: responseData.series[0].indice.map(e => e.PercetualIndiceRef),
				};
				const bov = {
					values: responseData.series[0].bovespa.map((e, index) => {
						return {
							name: categories[index],
							valor: e.valor,
							info:e.valor.toLocaleString('pt-BR') + " pts",
							y: e.PercetualIndiceRef,							
							y_info: e.PercetualIndiceRef.toFixed(2).toLocaleString('pt-br')
						};
					}),
					labels: responseData.series[0].bovespa.map(e => e.PercetualIndiceRef),
				};

				const categoriesList = [...responseData.periodos.periodo];
				const maxDate = convertBRLDateToDate(categoriesList.reverse()[0]);

				if (periodParam) {
					const dateList = [...responseData.periodos.periodo];

					setBeginDate(convertBRLDateToDate(dateList[0]));
					setEndDate(convertBRLDateToDate(dateList.reverse()[0]));
				}

				if ((beginDateParam || endDateParam) && maxDate !== endDate) {
					const dateList = [...responseData.periodos.periodo];
					// dateList = dateList.reverse();

					setBeginDate(convertBRLDateToDate(dateList[0]));
					setEndDate(convertBRLDateToDate(dateList.reverse()[0]));
				}


				setChart(prev => {
					return {
						...prev,
						xAxis: { categories },
						series: [
							{
								...prev?.series[0],
								data: etf.values,
							},
							{
								...prev?.series[1],
								data: ind.values,
							},
							{
								...prev?.series[2],
								data: bov.values,
							},
						],
					};
				});
			} else {
				if (!beginDateParam) {
					setBeginDate(new Date());
				}

				if (!endDateParam) {
					setEndDate(new Date());
				}

				setChart(prev => {
					return {
						...prev,
						xAxis: { categories: [] },

						series: [
							{
								...prev?.series[0],
								data: [],
							},
							{
								...prev?.series[1],
								data: [],
							},
							{
								...prev?.series[2],
								data: [],
							},
						],
					};
				});
			}
		} catch (err) {
			resetChart();

			console.error(
				'Ocorreu um erro ao chamar a API de Rentabilidade Acumalada - Erro: ',
				err,
			);
		}
	};

	useEffect(() => {
		const getData = async () => {
			getAnosReferencia();
			getDateAtualizacao();
			getChart(null, null, 3);
			getRentabilidadeMensal();
			getVolumeDiario();
			getEvolucaoDiaria();
			
		};

		getData();

		// eslint-disable-next-line
	}, []);

	const setActivePeriod = id => {
		if (id) {
			const items = Array.from(
				document.querySelectorAll('.rentabilidade-option'),
			);
			items.forEach(
				element =>
					(element.className = element.className.replace(' active', '')),
			);

			const item = document.getElementById(id);
			item.className += ' active';
		}
	};
	const handleOptionClick = async event => {
		setActivePeriod(event.target.id);

		const period = event.target.id.replace('-option', '');

		if (period === '') {
			return;
		}

		await getChart(null, null, periodLabel[period]);
	};
	const handleBeginDateChange = async date => {
		setBeginDate(date);

		setActivePeriod('acumulado-option');

		getChart(date, endDate, null);
	};
	const handleEndDateChange = async date => {
		setEndDate(date);

		setActivePeriod('acumulado-option');

		getChart(beginDate, date, null);
	};
	const handleMensalClick = async year => {
		try {
			setMensalData(null);

			var month = actualMonth;

			

			const response = await etfService.RentabilidadeMensal(year, actualMonth);
			const responseData = await response.data;

			const mensal = getMensal(
				responseData.ObjJsonResultado.RentabilidadeMensal,
			);

			setMensalData(mensal);
		} catch (err) {
			setMensalData([]);
		}
	};
	const handleVolumeClick = async (year, month) => {
		try {
			setVolumeData(null);

			const response = await etfService.RentabilidadeVolume(year, month);
			const responseData = await response.data;

			const volume = getVolume(responseData.ObjJsonResultado.VolumeNegociado);

			setVolumeData(volume);
		} catch (err) {
			setVolumeData([]);
		}
	};
	const handleEvolucaoClick = async (year, month) => {
		try {
			setEvolucaoData(null);

			const response = await etfService.RentabilidadeEvolucao(year, month);
			const responseData = await response.data;
			
			const evolucao = getEvolucao(
				responseData.ObjJsonResultado.EvolucaoDiaria,
			);
			console.log(evolucao);
			setEvolucaoData(evolucao);
		} catch (err) {
			setEvolucaoData([]);
		}
	};
	const handleDownloadClick = async path => {
		try {
			const response = await documentsService.downloadRentabilidade(path);
			const responseData = await response.data;

			const downloadUrl = window.URL.createObjectURL(
				new Blob([responseData], {
					type: 'application/vnd.ms-excel.sheet.macroEnabled.12',
				}),
			);

			const filename = path.replace('Download', '');
			const link = document.createElement('a');

			link.href = downloadUrl;
			link.download = `${filename}_${getDateTimeString()}.xlsx`;
			document.body.appendChild(link);

			link.click();

			link.remove();
		} catch (err) {
			console.error('An occurred while downloading file: ', err);
		}
	};

	return (
		<Container>
			<Hidden mdUp>
				<Title>Rentabilidade</Title>
			</Hidden>
			<Hidden smDown>
				<Submenu>
					<SubmenuItem
						onClick={() => smoothScroll('#acumulada')}
						label="Rentabilidade acumulada"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#mensal')}
						label="Rentabilidade mensal"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#volume')}
						label="Volume negociado"
					/>
					<SubmenuItem
						onClick={() => smoothScroll('#evolucao')}
						label="Evolução diária"
					/>
				</Submenu>
			</Hidden>

			<BoxAcumulado ref={acumuladoRef}>
				<ContentAcumulado>
					<h2 id="acumulada">Rentabilidade acumulada</h2>

					<div
						style={{
							display: 'flex',
							flexDirection: matches ? 'column' : 'row',
							justifyContent: matches ? 'center' : 'space-between',
							alignItems: 'center',
							margin: '20px 0px',
						}}
					>
						<PeriodOptions onClick={handleOptionClick}>
							<PeriodOption
								id="acumulado-option"
								className="rentabilidade-option"
								blockcursor={1}
							>
								Acumulado
							</PeriodOption>
							<PeriodOption id="6m-option" className="rentabilidade-option">
								6m
							</PeriodOption>
							<PeriodOption id="1a-option" className="rentabilidade-option">
								1a
							</PeriodOption>
							<PeriodOption
								id="inicio-option"
								className="rentabilidade-option active"
							>
								Início
							</PeriodOption>
						</PeriodOptions>

						<DateOptions>
							<MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
								<KeyboardDatePicker
									style={
										matches
											? { margin: '10px 25px' }
											: { width: '160px', margin: '0px 25px' }
									}
									disableToolbar
									variant={matches ? 'dialog' : 'inline'}
									format="dd/MM/yyyy"
									id="beginDate"
									cancelLabel="Cancelar"
									// label="Date picker inline"
									value={beginDate}
									onChange={handleBeginDateChange}
									KeyboardButtonProps={{
										'aria-label': 'change date',
									}}
								/>
								<span style={matches ? { display: 'none' } : {}}>a</span>
								<KeyboardDatePicker
									style={
										matches
											? { margin: '10px 25px' }
											: { width: '160px', margin: '0px 25px' }
									}
									disableToolbar
									variant="inline"
									format="dd/MM/yyyy"
									id="endDate"
									cancelLabel="Cancelar"
									// label="Date picker inline"
									value={endDate}
									onChange={handleEndDateChange}
									KeyboardButtonProps={{
										'aria-label': 'change date',
									}}
								/>
							</MuiPickersUtilsProvider>
						</DateOptions>
					</div>

					{chart.series[0].data ? (
						chart.series[0].data?.length > 0 ? (
							<HighchartsReact
								highcharts={Highcharts}
								options={chart}
							// highcharts={HighStock}
							// constructorType={'stockChart'}
							/>
						) : (
								<div
									className="LoadingContainer"
									style={{
										display: 'flex',
										justifyContent: 'center',
										alignItems: 'center',
										height: '75%',
									}}
								>
									Não há dados a serem exibidos
								</div>
							)
					) : (
							<div
								className="LoadingContainer"
								style={{
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									height: '75%',
								}}
							>
								<Loader type="Oval" height={100} width={100} />
							</div>
						)}
				</ContentAcumulado>
			</BoxAcumulado>
			
			<BoxMensal>
				<ContentMensal ref={mensalRef}>
					<div>
						<h2 id="mensal">Rentabilidade mensal</h2>

						<TabelaMensal>
							<TabelaCalendario
								variant="dark-blue"
								reference="mon"
								headers={[
									'Mês',
									'Cota patrimonial (%)',
									'Índice de referência (%)',
									'Cota patrimonial vs Índice de referência (%)',
								]}
								data={mensalData}
								buttonText="Rentabilidade completa"
								onClick={handleMensalClick}
								onDownloadClick={() =>
									handleDownloadClick('DownloadRentabilidadeMensal')
								}
								hideFilterMonth={true}
								anosReferencia={anosReferencia}
								hidePagination={true}
								showUpdateDate={true}
								updateDate={rentabilidadeMensalDate}
								textColorPagination="white"
							/>
						</TabelaMensal>
					</div>
				</ContentMensal>
			</BoxMensal>

			<BoxVolume>
				<ContentVolume ref={volumeRef}>
					<div>
						<h2 id="volume">Volume negociado</h2>

						<TabelaVolume>
							<TabelaCalendario
								variant={matches ? 'light-blue' : 'white'}
								reference="vol"
								headers={['Data', 'Volume negociado (R$)']}
								data={volumeData}
								buttonText="Volume completo"
								onClick={handleVolumeClick}
								onDownloadClick={() =>
									handleDownloadClick('DownloadVolumeNegociado')
								}
								anosReferencia={anosReferencia}
								rowsPerPageInit={10}
								hidePagination={false}
								textColorPagination="darkblue"
								backgroudColorPagination="darkblue"
								showUpdateDate={true}
								updateDate={volumeNegociadoDate}
							/>
						</TabelaVolume>
					</div>
				</ContentVolume>
			</BoxVolume>

			<BoxEvolucao>
				<ContentEvolucao ref={evolucaoRef}>
					<h2 id="evolucao">Evolução diária</h2>

					<TabelaEvolucao>
						<TabelaCalendario
							variant="white"
							reference="evo"
							data={evolucaoData}
							buttonText="Evolução completa"
							headers={[
								'Data',
								'Patrimônio líquido (R$)',
								'Cota patrimonial (R$)',
								'Cotação do ETF na B3 (R$)',
								'Índice de referência (R$)',
								'Ágio/Deságio - Cotação vs Índice (%)',
								'Ágio/Deságio - Cotação vs Cota patrimonial (%)',
							]}
							// customHeader={<EvolucaoHeader count={11} />}
							onClick={handleEvolucaoClick}
							onDownloadClick={() =>
								handleDownloadClick('DownloadEvolucaoDiaria')
							}
							anosReferencia={anosReferencia}
							rowsPerPageInit={9}
							hidePagination={false}
							textColorPagination="darkblue"
							backgroudColorPagination="darkblue"
							showUpdateDate={true}
							updateDate={evolucaoDiariaDate}
						/>
					</TabelaEvolucao>
				</ContentEvolucao>
			</BoxEvolucao>
		</Container>
	);
};
